/*
 * @Author: irenedeng 
 * @Date: 2019-03-08 14:34:30 
 * @Last Modified by: irenedeng
 * @Last Modified time: 2019-04-09 11:58:25
 * 
 * @desc 特权启动的特殊弹框
 */

import { format } from '../base/string';

import ajaxCall from '../common/ajaxcall';
import report11332 from '../report/11332_batch';
import * as Base from '../base/mbase';
import wxBridge from '../jsbridge/jsbridge_login_queue';
import '../jsapis/getGameData';
import '../jsapis/setGameData';

function NONE(){}
var Util = {
    isElementInViewport: function(el) {
        var rect = el.getBoundingClientRect();

        var width_st = rect.width / 2,
            height_st = rect.height / 2;

        var innerHeight = window.innerHeight,
            innerWidth  = window.innerWidth;

        var clientHeight = document.documentElement.clientHeight,
            clientWidth  = document.documentElement.clientWidth;

        return (
            rect.height > 0 
            && rect.width  > 0 
            &&  (  ( rect.top  >= 0 && rect.top <= innerHeight - height_st )
                || ( rect.bottom  >= height_st && rect.bottom <= innerHeight ) )
            &&  (  ( rect.left >= 0 && rect.left <= innerWidth - width_st  )
                || ( rect.right >= width_st && rect.right <= innerWidth  ) )
        );
    }, 
    debounce: function(callback, t, context) {
        var timer;

        return function () {
            var args = arguments;

            if (timer) {
                return;
            }

            timer = setTimeout(function () {
                callback.apply(context, args);
                timer = null;
            }, t)
        }
    },
    log: function() {
        var args = arguments;

        try {
            if ( window.logInfo || logInfo ) {
                logInfo.apply(window, args)
            } else {
                console.log.apply(null, args);
            }
        } catch(e) {
           console.log(e);
       }
    },
};

Popup.instance = null;

function Popup(opt){

    var item = this;
    if ( Popup.instance ) {
        item = Popup.instance;
    } else {
        item = this;
    }

    item.appid = opt.appid;
    item.succCbk   = opt.success;   // 点了确定按钮
    item.cancelCbk = opt.cancel;    // 点了遮罩取消
    item.failCbk   = opt.fail;      // 如果过程有失败，走正常逻辑
    item.ssid      = opt.ssid || 0;

    item.waitingList = [];
    item.reportHandler = item.throttleReport();


    if ( Popup.instance ) {
        Popup.instance.init();
        return Popup.instance;
    }

    this.isInited  = false;

    this.doms = {};
    this.data = {};

    this.init();

    Popup.instance = this;


    return this;
}

Popup.prototype.init = function(){
    var that = this;

    Promise.all(
        [that.appendCSS(), that.getLastData(), that.queryPrivilege()]
    ).then(function(res){
            var lastData = res[1];
            var data     = res[2];

            if(data.errcode == 0) {
                that.data = data;

                Util.log('[privilege popup]', 'data', data)
                Util.log('[privilege popup]', 'last data', lastData)

                // 分析当前数据和上次数据返回是否有不同，是否需要重新弹窗
                // 并且是有内容的才展示
                if (   that.isDifferent(data, lastData) 
                    && data.function_list && data.function_list.length ) {

                    that.initView(data);
                    that.bindEvent();
                    that.reportPV();

                    Util.log('[privilege popup]', 'initView')

                } else {
                    that.succCbk({
                        extern_info: data.extern_info
                    })

                    Util.log('[privilege popup]', 'same as last time, not show up')
                }

                that.storeData(data);
                
            } else {
                that.failCbk();

                Util.log('[privilege popup]', 'get data fail', JSON.stringify(data));
            }
            
    }).catch(function(err){
        that.failCbk()

        Util.log('[privilege popup]', 'promise err', JSON.stringify(err));

    }) 

}

Popup.prototype.isDifferent = function(newData, oldData){
    var ret = false;
    var newFuncList = newData.function_list || [],
        oldFuncList = oldData.function_list || [];
    var newFuncMap = {},
        oldFuncMap = {};

    newFuncList.forEach(function(func){
        newFuncMap[func.key] = func.state
    })
    oldFuncList.forEach(function(func){
        oldFuncMap[func.key] = func.state
    })

    for( var key in newFuncMap ) {
        if ( !(key in oldFuncMap) ) {
            ret = true;
        }
        if ( newFuncMap[key] != oldFuncMap[key] ) {
            ret = true
        }
    }

    for( var key in oldFuncMap ) {
        if ( !(key in newFuncMap) ) {
            ret = true;
        }
        if ( newFuncMap[key] != oldFuncMap[key] ) {
            ret = true
        }
    }

    return ret;
    
}

var KEY = {
    privilege_data: 'privilege_data_'
};

Popup.prototype.storeData = function(data) {
    var that = this;

    wxBridge.setGameData({
        key: KEY.privilege_data + that.appid,
        value: JSON.stringify(data),        
    })
}

Popup.prototype.getLastData = function(data) {
    var that = this;
    
    return new Promise(function(resolve, reject) {
        wxBridge.getGameData({
            key: KEY.privilege_data + that.appid,
        }, function(res) {
            if ( res.err_msg.indexOf('ok') != -1 ) {
                var ret;
    
                try {
                    ret = JSON.parse(res.value);
                } catch(e) {
                    ret = {};
                }
    
                resolve(ret);
            } else {
                reject();
            }
        })
    })
}

Popup.prototype.appendCSS = function(){
    var that = this;

    return new Promise(function(resolve, reject) {
        if ( that.cssLink ) {
            resolve();
            return;
        }
    
        var link = document.createElement('link');
        link.setAttribute('rel', 'stylesheet');
        link.href = '//res.wx.qq.com/wechatgame/product/wechat-download/dist/css/style-privilege.57446412.css';
    
        link.onload = function(){
            resolve();
        }
        link.onerror = function(){
            reject();
        }
    
        document.head.appendChild(link);
    
        that.cssLink = link;
    })
}


Popup.prototype.reportPV = function(){
    var that = this;
    var container = that.doms.container,
        listItems = Array.prototype.slice.call(
            that.doms.list.getElementsByClassName('game-download__privilege-item'),
            0
        );
    var function_list = that.data.function_list; 
        


    if ( !container.getAttribute('reported') && Util.isElementInViewport(container) ) {
        that.report({
            uia: 0,
            aid: 1,
        })

        container.setAttribute('reported', true)
    }

    listItems.forEach(function(itemDom, index) {
        var func_data = function_list[index];

        if ( !itemDom.getAttribute('reported') && Util.isElementInViewport(itemDom) ) {
            that.report({
                uia: 8501,
                aid: 1,
                pid: index + 1,
                ext: encodeURIComponent(JSON.stringify({
                    title: func_data.title,
                    state: func_data.state
                }))
            })
    
            itemDom.setAttribute('reported', true)
        }
    })

}

Popup.prototype.report = function(obj) {
    var that = this;
    var map  = {
        scene   : 'iSceneId',
        uia     : 'iUIArea',
        pid     : 'iPositionId',
        ext     : 'sExternInfo',
        aid     : 'iActionId',
        op      : 'iOpType',
        gid     : 'sGameId',
        ssid    : 'iSourceSceneId'
    };

    var defaultRep = {
        gid     : that.appid,
        scene   : 85,
        op      : 1,
        ssid    : that.ssid
    };

    var rep = Base.extend(defaultRep, obj);
    
    for ( var key in rep ) {
        if ( map[key] ) {
            rep[map[key]] = rep[key];

            delete rep[key];
        }
    }

    that.waitingList.push(rep);
    that.reportHandler(rep);
}

Popup.prototype.throttleReport = function(data){
    var that = this;

    return Util.debounce(function(data){

        report11332(that.waitingList);
        that.waitingList = [];

    }, 100)
}


Popup.prototype.queryPrivilege = function(){
    // 向后台请求具体特权信息
    var that = this;

    return new Promise(function(resolve, reject){
        ajaxCall(
            '/cgi-bin/gamewap/getlaunchprivilegefunctioninfo',
            {
                appid: that.appid
            },
            function(res){
                resolve(res)
            },
            function(){
                reject()
            }   
        )
    })
}

Popup.prototype.unBindEvent = function(){
    var that = this;

    that.doms.btn.onclick = null;
    that.doms.mask.onclick = null;

    that.doms.container.ontouchmove = null;
}

Popup.prototype.hideContainer = function(){
    Util.log('[privilege popup]', 'hide container', this.appid)

    var root = document.getElementsByTagName( 'html' )[0];

    this.doms.container.style.display = 'none';
    document.body.className = document.body.className.replace(' game-download__body-stop-scroll', '');
    // root.className = root.className.replace(' game-download__body-stop-scroll', '');
    // root.style.overflow = '';
}

Popup.prototype.showContainer = function(){

    Util.log('[privilege popup]', 'show container', this.appid)

    var root = document.getElementsByTagName( 'html' )[0];

    this.doms.container.style.display = '';
    document.body.className += ' game-download__body-stop-scroll';
    // root.className += ' game-download__body-stop-scroll';
    // root.style.overflow='hidden'
}

Popup.prototype.bindEvent = function(){
    var that = this;

    that.doms.btn.onclick = function(){

        Util.log('[privilege popup]', 'enter game', that.appid)

        that.hideContainer();

        that.report({
            uia: 8502,
            pid: 1,
            aid: 2,
            op : 2
        })

        setTimeout(function(){
            that.succCbk({
                appid: that.appid,
                extern_info: that.data.extern_info || ''
            })
        }, 20)
        

    }

    that.doms.mask.onclick = function(){
        that.cancelCbk({
            appid: that.appid
        })

        that.hideContainer();
    }

    var listDom = that.doms.list;

    var startY;
    var docScrollTop, docScrollLeft;
    listDom.ontouchstart = function(event){
        docScrollTop = document.body.scrollTop;
        docScrollLeft = document.body.scrollLeft;

        startY = event.changedTouches[0].screenY;
    }

    // that.doms.container.ontouchstart = function(event){
    //     docScrollTop = document.body.scrollTop;
    //     docScrollLeft = document.body.scrollLeft;

    //     startY = event.changedTouches[0].screenY;
    // }

    that.doms.mask.onscroll = function(event) {
        // event.preventDefault();
        // event.stopPropagation();
    }

    that.doms.container.ontouchmove = function(event){
        var point = event.changedTouches[0],
            target = event.target;

        var isInListDom = false;

        while(target != that.doms.container) {
            if ( target == that.doms.list ) {
                isInListDom = true;
                break;
            }

            target = target.parentNode;
        }

        // window.scrollTo(docScrollLeft, docScrollTop);

        if ( !isInListDom ) {
            event.preventDefault();
        }

        that.reportPV();
    }


    
    listDom.ontouchmove = function(event) {
        var changedTouches = event.changedTouches, canMove = false;
        var scrollTop = this.scrollTop;
        var offsetHeight = listDom.offsetHeight,
            scrollHeight = listDom.scrollHeight;

        if (changedTouches.length > 0) {
            var touch = changedTouches[0] || {};
            var moveY = touch.screenY;
            if ( (moveY - startY) > 0  && scrollTop <= 0) {
                canMove = false;
            } else if ((moveY - startY) < 0 && scrollTop + offsetHeight >= scrollHeight) {
                canMove = false;
            }else{
                canMove = true;
            }

            // document.body.scrollTop = docScrollTop;
            console.log('set scrollTop', document.body.scrollTop);
            // window.scrollTo(docScrollLeft, docScrollTop);

            if (!canMove) {
                event.preventDefault();
            } else {
                event.stopPropagation();
                return;
            }

        }
    }
}

Popup.prototype.initView = function(data){
    var that = this;

    var tpl = ' \
        <div style="z-index:100000;position: fixed;" class="game-download"> \
            <div class="game-download__privilege-popup"> \
                {topHtml} \
                <div class="game-download__privilege-list"> \
                    {itemListHtml}\
                </div> \
                <div class="game-download__privilege-bottom"> \
                    <div class="game-download__privilege-bottom-btn">进入游戏</div> \
                </div> \
            </div> \
            <div class="game-download__privilege-mask"></div> \
        </div> \
    ';

    var topTpl = '\
        <div class="game-download__privilege-top {noIconClass}"> \
            <div class="game-download__privilege-top-icon"> \
                <img src="{icon}"> \
            </div> \
            <div class="game-download__privilege-top-text"> \
                <div class="game-download__privilege-top-title">{title}</div> \
                <div class="game-download__privilege-top-subtitle">{sub_title}</div> \
            </div> \
        </div> \
    '

    // item 有 new / available 或者普通的desc
    var itemTpl = ' \
        <div class="game-download__privilege-item {itemClass}"> \
            <span class="game-download__privilege-item-icon"> \
                <img src="{icon}"> \
            </span> \
            <span class="game-download__privilege-item-text">{title}</span> \
            <span class="game-download__privilege-item-state_base {stateClass}"> \
                {desc} \
            </span> \
        </div> \
    ';

    var hasIcon = data.icon && data.icon.length;
    var noIconClass = 'game-download__privilege-top_without-icon';

    var topHtml = format(topTpl, {
        noIconClass: hasIcon ? '' : noIconClass,
        title: data.title,
        icon: data.icon ? data.icon : '//',
    });

    topHtml = format(topHtml, {
        sub_title: data.sub_title || ''
    }, false)

    var itemListHtml = '';
    // 正常使用=1，new=2，维护中=3，不满足使用条件=4，手动关闭=5，规划中=6
    var itemAndStateClassMap = {
        1: 'game-download__privilege-item-state_available',
        2: 'game-download__privilege-item-state_new',
        3: 'game-download__privilege-item_disable',
        4: 'game-download__privilege-item_disable',
        5: 'game-download__privilege-item_disable',
        6: 'game-download__privilege-item_disable',
    };
    data.function_list.forEach(function(func){
        var itemClass = '',
            stateClass = '';

        if ( func.state == 1 || func.state == 2 ) {
            stateClass = itemAndStateClassMap[func.state]
        } else {
            itemClass = itemAndStateClassMap[func.state];
        }

        if ( func.desc && func.desc.length ) {
            stateClass = '';
        }

        itemListHtml += format(itemTpl, {
            itemClass   : itemClass,
            stateClass  : stateClass,
            desc        : func.desc     || '',
            title       : func.title    || '',
            icon        : func.icon     || '//'
        })
        
    })

    var html = format(tpl, {
        itemListHtml: itemListHtml,
        topHtml: topHtml,
        title: data.title,
        sub_title: data.sub_title || ''
    }, false)

    var container;
    
    // 已经有container在，重新填充
    if ( that.doms.container ) {
        container = that.doms.container;

        container.innerHTML = html;

    } else {
        container = document.createElement('div');
        container.style.width = '100%';
        container.style.height = '100%';
        container.style.position = 'fixed';
        container.style.top = '0';
        container.style.zIndex = '10000';
        container.style.display = 'none';

        container.innerHTML = html;
        document.body.appendChild(container);

        console.warn('append child', container)
        that.isInited = true;

    }
    
    // 等渲染完成以后
    that.doms = {
        container: container,
        mask     : container.getElementsByClassName('game-download__privilege-mask')[0],
        btn      : container.getElementsByClassName('game-download__privilege-bottom-btn')[0],
        list     : container.getElementsByClassName('game-download__privilege-list')[0]
    };

    that.showContainer();

    
}


export default Popup;